import { isEmpty } from 'lodash-es'
import { IExtendedColDef } from 'app/services/api/agGrid/agGrid'
import { getSimplifiedType } from 'common/utils/cbvUtils'

/**
 * Hardcoded ColDef modification logic
 * To include additional logic that is ommited by API response
 * or functions that simply cannot be part of the response.
 */
export const initialColDefsModifier = (originalColDefs: IExtendedColDef[]) => {
  const nonDataQualityColDefs = originalColDefs.filter(
    (cd) => !cd.isDataQualityColumn
  )

  const dataQualityColDefs = originalColDefs.filter(
    (cd) => cd.isDataQualityColumn
  )

  const combinedColDefs: IExtendedColDef[] = [...nonDataQualityColDefs]

  dataQualityColDefs.forEach((dqCd) => {
    /**
     * Put "{column name} data quality" column directly after the orignal
     * source column
     */
    const code = dqCd.code?.replace(/(_Data_Source|Dq)$/, '')
    const idx = combinedColDefs.findIndex((cd) => cd.code === code)

    combinedColDefs.splice(idx + 1, 0, dqCd)
  })

  const res = combinedColDefs.map((cd) => {
    // destructure fields unrecognized by ag-grid to remove console warnings
    const { dataType, attributeEnums, code, name, ...newCd } = cd

    newCd.field ??= code
    newCd.headerName ??= name

    /**
     * NOTE: somehow setting a small base width makes auto resize
     *       account for header length..
     *
     * NOTE: auto resize does not apply to hidden columns, so we need
     *       to set a more reasonable default length.
     */
    const headerNameLength = newCd.headerName?.length ?? 20
    const horizontalPadding = 32 * 1.75

    newCd.width = horizontalPadding + headerNameLength * 7

    if (newCd.filter == null && dataType != null) {
      if (dataType === 'date') {
        newCd.filter = 'agDateColumnFilter'

        if (newCd.field === 'FromDate') {
          newCd.valueFormatter = (params) => {
            return isEmpty(params.value)
              ? ''
              : String(params.value).split('T')[0]
          }
        } else if (newCd.field === 'ToDate') {
          newCd.valueFormatter = (params) => {
            return isEmpty(params.value)
              ? ''
              : String(params.value).split('T')[0]
          }
        }
      } else {
        switch (getSimplifiedType(dataType)) {
          case 'boolean': {
            newCd.filter = 'agSetColumnFilter'

            newCd.filterParams = {
              values: [true, false]
            }

            break
          }

          case 'number': {
            newCd.filter = 'agNumberColumnFilter'

            break
          }

          case 'string': {
            newCd.filter = 'agTextColumnFilter'

            if (attributeEnums != null && attributeEnums.length > 0) {
              /**
               * NOTE:
               * - any string column with Enum is considered a code column
               * - most code column has field name ending with `Code`
               *   - exceptions being Consquence Area `AssessmentMethod`
               * - code column row data now consist of name instead of code
               * - code column API filter will filter on name
               */
              newCd.filter = 'agSetColumnFilter'

              newCd.filterParams = {
                values: attributeEnums.map((dto) => dto.name)
              }
            }

            break
          }
        }
      }
    }

    return newCd
  })

  return res
}
